import PropTypes from 'prop-types';
import React from 'react';
import { GENDER } from '~graphql-types';
import { GenderFemale, GenderMale, GenderMix } from '~svg-components';

function Gender({ type, ...otherProps }) {
  if (type === GENDER.MALE) {
    return <GenderMale color="blue" {...otherProps} />;
  }
  if (type === GENDER.FEMALE) {
    return <GenderFemale color="rose" {...otherProps} />;
  }
  if (type === GENDER.NEUTRAL) {
    return <GenderMix color="violet" {...otherProps} />;
  }
  return null;
}

Gender.propTypes = {
  type: PropTypes.oneOf(Object.values(GENDER)),
};

Gender.defaultProps = {
  type: undefined,
};

export default Gender;
